var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pause"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.14551 11.6667V2.33333C2.14551 2.01116 2.40667 1.75 2.72884 1.75H5.06217C5.38435 1.75 5.64551 2.01116 5.64551 2.33333V11.6667C5.64551 11.9888 5.38435 12.25 5.06217 12.25H2.72884C2.40667 12.25 2.14551 11.9888 2.14551 11.6667ZM8.56217 12.25H10.8955C11.2177 12.25 11.4788 11.9888 11.4788 11.6667V2.33333C11.4788 2.01116 11.2177 1.75 10.8955 1.75H8.56217C8.24 1.75 7.97884 2.01116 7.97884 2.33333V11.6667C7.97884 11.9888 8.24 12.25 8.56217 12.25Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseNotifications);
export default __webpack_public_path__ + "static/media/pause-notifications.1f5307030b0d2c89c1a8a9d6c181f604.svg";
export { ForwardRef as ReactComponent };